import { Calendar } from "lucide-react"
import { colors } from "../../styles/theme"
import { Event } from "./types"
import { StatusBadge } from "./StatusBadge"

interface EventListProps {
  events: Event[]
  selectedEvent: string
  onEventSelect: (eventId: string) => void
  formatDateForDisplay: (dateString: string) => string
}

export function EventList({ events, selectedEvent, onEventSelect, formatDateForDisplay }: EventListProps) {
  return (
    <div
      className="border rounded-xl"
      style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
    >
      <div className="p-4 border-b" style={{ borderColor: colors.border.primary }}>
        <h3 className="text-sm font-medium" style={{ color: colors.text.primary }}>
          Drag Racing Series Events
        </h3>
      </div>
      <div className="p-2">
        {events.length === 0 ? (
          <div className="p-8 text-center">
            <Calendar className="h-8 w-8 mx-auto mb-2" style={{ color: colors.text.tertiary }} />
            <p className="text-sm" style={{ color: colors.text.secondary }}>
              No completed or live drag racing series events found
            </p>
            <p className="text-xs mt-1" style={{ color: colors.text.tertiary }}>
              Only completed and live multi-date drag racing series are shown here
            </p>
          </div>
        ) : (
          <div className="space-y-1">
            {events.map((event) => (
              <button
                key={event.id}
                onClick={() => onEventSelect(event.id)}
                className={`w-full text-left p-3 rounded-lg transition-colors border ${
                  selectedEvent === event.id ? "border-rose-500" : "border-transparent hover:border-gray-600"
                }`}
                style={{
                  backgroundColor: selectedEvent === event.id ? colors.primary[950] : "transparent",
                  borderColor: selectedEvent === event.id ? colors.primary[500] : "transparent",
                }}
              >
                <div className="flex items-start justify-between mb-2">
                  <h4 className="text-sm font-medium" style={{ color: colors.text.primary }}>
                    {event.name}
                  </h4>
                  <StatusBadge status={event.status} />
                </div>
                <div
                  className="flex items-center justify-between text-xs mb-1"
                  style={{ color: colors.text.secondary }}
                >
                  <span>{formatDateForDisplay(event.event_date)}</span>
                  <span>{event.participants} drivers</span>
                </div>
                <div className="text-xs" style={{ color: colors.text.secondary }}>
                  {event.location}
                </div>
                {event.event_dates && event.event_dates.length > 1 && (
                  <div className="mt-2 flex items-center gap-1">
                    <Calendar className="h-3 w-3" style={{ color: colors.text.tertiary }} />
                    <span className="text-xs" style={{ color: colors.text.secondary }}>
                      {event.event_dates.length} dates in series
                    </span>
                  </div>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
} 